<template>
  <div>
    <b-container id="form" fluid>
      <b-row class="px-3">
        <b-col cols="auto" class="my-2">
          <!--                    <datepicker-->
          <!--                            :minimum-view="'day'"-->
          <!--                            format="d/MM/yyyy"-->
          <!--                            v-model="filter.dateOne"-->
          <!--                            input-class="date-box"-->
          <!--                            clear-button-->
          <!--                            @input="filters(filter)"></datepicker>-->
          <div
            class="datepicker-trigger input-group"
            @mouseover="activeCloseDate = true"
            @mouseleave="activeCloseDate = false"
          >
            <input
              id="datepicker"
              class="form-control border-right-0"
              type="text"
              autocomplete="off"
              placeholder="เลือกวันที่"
              :value="formatDates(filter.dateOne, filter.dateTwo)"
            />
            <div class="input-group-prepend bg-white">
              <span
                id="basic-addon1"
                class="input-group-text border-left-0 rounded-right bg-white"
              >
                <fa-icon
                  :style="{
                    opacity: activeCloseDate ? 1 : 0,
                  }"
                  :icon="['fas', 'times']"
                  class="icon"
                  @click="clearDate"
                />
              </span>
            </div>

            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker'"
              :mode="'range'"
              :show-shortcuts-menu-trigger="false"
              :fullscreen-mobile="true"
              :date-one="filter.dateOne"
              :date-two="filter.dateTwo"
              @date-one-selected="
                (val) => {
                  filter.dateOne = val;
                }
              "
              @date-two-selected="
                (val) => {
                  filter.dateTwo = val;
                }
              "
            />
          </div>
        </b-col>
        <b-col cols="auto" class="my-2">
          <multiselect
            v-model="filter.direction"
            style="min-width: 200px;"
            :tabindex="-1"
            :options="direction"
            label="direction"
            track-by="id"
            select-label
            deselect-label="✖"
            selected-label
            placeholder="เส้นทางวิ่ง"
          />
        </b-col>
        <b-col cols="auto" class="my-2">
          <div class="search">
            <input
              v-model="filter.name"
              type="search"
              class="form-control"
              placeholder="ชื่อสถานพยาบาล"
              style="min-width: 150px;"
            />
          </div>
        </b-col>
        <b-col cols="auto" class="my-auto" px-1px>
          <div class="search-icon" @click="filters(filter)">
            <fa-icon icon="search" />
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-table :fields="fields" :items="items.data" striped bordered responsive>
      <template slot="-" slot-scope="data">
        <label class="check-box">
          <input id="exampleCheck1" type="checkbox" :value="data.item.id" />
          <span class="checkmark" />
        </label>
      </template>
      <template slot="no" slot-scope="data">
        <div class="col-right">{{ data.index + items.from }}</div>
      </template>
      <!-- A virtual composite column -->
      <template slot="เส้นทางวิ่ง" slot-scope="data">
        <div class="col-left">
          {{
            data.item.direction_info.direction
              ? data.item.direction_info.direction.direction
              : ""
          }}
        </div>
      </template>
      <template slot="code" slot-scope="data">
        <div class="col-right">{{ data.item.code }}</div>
      </template>
      <template slot="ชื่อสถานพยาบาล" slot-scope="data">
        <div class="col-left">
          <a @click="goHospitalPage(data.item.id)">
            <u>{{ data.item.name }}</u>
          </a>
        </div>
      </template>
      <template slot="ที่อยู่" slot-scope="data">
        <div class="col-left">
          {{ data.item.address }} {{ data.item.road }}
          {{ data.item.districts_name }}
          {{ data.item.sub_districts_name }}
          {{ data.item.province_name }} {{ data.item.postal_code }}
        </div>
      </template>
      <template slot="วันเวลาอัพเดทล่าสุด" slot-scope="data">
        <div class="col-center">{{ moment(data.item.updated_at) }}</div>
      </template>
      <template slot="phone" slot-scope="data">
        <div class="col-left">{{ data.item.phone }}</div>
      </template>
      <template slot="email" slot-scope="data">
        <div class="col-left">{{ data.item.email }}</div>
      </template>
      <template slot="action" slot-scope="data">
        <div class="col-left">
          <b-button
            size="sm"
            class="btn-danger"
            block
            @click="deleteHospitalHandler(data.item.id)"
            >ลบ</b-button
          >
        </div>
      </template>
    </b-table>
    <div v-if="items.data ? items.data.length <= 0 : true">ไม่พบข้อมูล</div>
    <b-pagination
      v-model="items.current_page"
      size="md"
      :total-rows="items.total"
      :per-page="items.per_page"
      @input="getDataPerPage(items.current_page)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment-timezone";
import format from "date-fns/format";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    // Datepicker
  },
  data() {
    return {
      activeCloseDate: false,
      fields: [
        // "-",
        "no",
        { key: "เส้นทางวิ่ง", label: "เส้นทางวิ่ง" },
        { key: "code", label: "รหัส" },
        "ชื่อสถานพยาบาล",
        "ที่อยู่",
        { key: "phone", label: "เบอร์โทร" },
        { key: "email", label: "EMAIL" },

        "วันเวลาอัพเดทล่าสุด",
        { key: "action", label: "ACTION" },
      ],
      dateFormat: "D/MM/YYYY",
    };
  },
  watch: {
    // "filter.dateOne"(value) {
    //     this.setDateFilter({...this.dateFilter, dateOne: value})
    // },
    // "filter.dateTwo"() {
    //     this.setDateFilter({...this.dateFilter, dateTwo: value})
    // }
  },
  mounted() {
    // console.log(this.filter.direction)
  },
  created() {
    const res = {
      page_no: this.filter.page_no,
      direction_id: this.filter.direction,
      name: this.filter.name,
      start_date: this.filter.dateOne,
      end_date: this.filter.dateTwo,
    };
    // var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
    // this.filter.dateOne = today;
    this.$nextTick((val) => {
      // this.$store.state.isLoading = true;
      // this.filterHospital(res).then(() => {
      //   this.$store.state.isLoading = false;
      // });
    });

    // this.resetData();
  },
  computed: {
    ...mapGetters({
      items: "Hospital/getDataFromFilter",
      direction: "Direction/getAll",
      getFilter: "Hospital/getFilter",
    }),
    filter: {
      get() {
        return this.getFilter;
      },
      set(value) {
        this.setFilter(value);
      },
    },
  },
  methods: {
    ...mapActions({
      filterHospital: "Hospital/filterData",
      setData: "Hospital/setData",
      getHospitals: "Hospital/getAll",
      setMessage: "Hospital/setMessage",
      resetData: "Hospital/resetData",
      setAdding: "History/setAdding",
      deleteHospital: "Hospital/deleteHospital",
      setFilter: "Hospital/setFilter",
    }),
    async goHospitalPage(id) {
      this.$store.state.isLoading = true;

      try {
        await this.setData(id);
      } catch (error) {
        this.$swal.fire("Error", error, "error");
        this.$store.state.isLoading = false;
        return;
      }

      this.$store.state.isLoading = false;

      this.goHistoryAdding();
    },
    goHistoryAdding() {
      const addingCustomer = false;
      const addingAnimal = false;

      this.setAdding({ addingCustomer, addingAnimal });
      let routeData = this.$router.resolve({ name: "history-customer-adding" });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "history-customer-adding" });
    },
    moment: function(date) {
      return moment(date)
        .tz("Asia/Bangkok")
        .format("D-MM-YYYY  h:mm:ss");
    },
    async filters(obj) {
      // console.log("date-one" + moment(obj.dateOne).format("DD-MM-YYYY"));
      // console.log(obj.dateTwo);
      this.$store.state.isLoading = true;
      let val = {};
      if (obj.dateTwo == "") {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          name: obj.name ? obj.name : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateOne ? moment(obj.dateOne).format("YYYY-MM-DD") : "",
        };
      } else {
        val = {
          page_no: obj.page_no != null ? obj.page_no : "1",
          direction_id: obj.direction != null ? obj.direction.id : "",
          name: obj.name ? obj.name : "",
          start_date: obj.dateOne
            ? moment(obj.dateOne).format("YYYY-MM-DD")
            : "",
          end_date: obj.dateTwo ? moment(obj.dateTwo).format("YYYY-MM-DD") : "",
        };
      }
      await this.filterHospital(val);
      this.$store.state.isLoading = false;
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    clearDate() {
      this.filter.dateOne = "";
      this.filter.dateTwo = "";
      this.filters(this.filter);
    },
    async getDataPerPage(pageNo) {
      if (pageNo == null) return;
      console.log("getDataPage", pageNo);
      this.$store.state.isLoading = true;
      this.filter.page_no = pageNo;
      await this.filters(this.filter);
      this.$store.state.isLoading = false;
    },
    deleteHospitalHandler(id) {
      this.$swal
        .fire({
          title: "กรอกรหัสผ่านยืนยันการลบ",
          input: "password",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "ลบ",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
          preConfirm: (password) => {
            return this.deleteHospital({ id, payload: { password } })
              .then((res) => {
                if (!res) {
                  this.$swal.showValidationMessage(`รหัสผ่านไม่ถูกต้อง`);
                }
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        })
        .then((result) => {
          if (result.value) {
            const res = {
              page_no: this.filter.page_no,
              direction_id: this.filter.direction,
              name: this.filter.name,
              start_date: this.filter.dateOne,
              end_date: this.filter.dateTwo,
            };
            // var today = moment.tz("Asia/Bangkok").format("YYYY-MM-DD");
            // this.filter.dateOne = today;
            this.$nextTick((val) => {
              this.filterHospital(res);
              this.getHospitals();
              this.$swal.fire(
                "เสร็จสิ้น",
                "ลบโรงพยาบาลเรียบร้อยแล้ว",
                "success"
              );
            });
          }
        });
    },
  },
};
</script>
<style scoped>
#form {
  background-color: #eaeced;
  padding: 5px;
  /* margin-left: 1px; */
  /* margin-right: 1px; */
  /* display: flex; */
  /* flex-direction: column; */
  /* justify-content: center; */
  /* height: 50px; */
}
.search-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.search {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.box {
  max-width: 150px;
}
.select-box {
  margin: 0px 5px 0px 5px;
  justify-content: center;
  width: 20vw;
  padding-left: 0px;
}
.search-icon {
  align-self: center;
  align-items: center;
  margin: 0px 0px 0px 10px;
  cursor: pointer;
}
.flex {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  margin-left: 0px;
}
.date-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 20vw;
}
a {
  color: black;
  cursor: pointer;
}
.datepicker-trigger {
  display: flex;
}
.icon {
  cursor: pointer;
}
</style>
